import React, { ReactNode } from "react";
import {
  AuthProvider as OidcAuthProvider,
  AuthProviderProps as OidcAuthProviderProps,
} from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

interface AuthProviderProps {
  children: ReactNode;
}

// OIDC configuration for Authentik
const oidcConfig: OidcAuthProviderProps = {
  authority: process.env.REACT_APP_OAUTH_ISSUER || "",
  client_id: process.env.REACT_APP_OAUTH_CLIENT_ID || "",
  redirect_uri:
    process.env.REACT_APP_OAUTH_REDIRECT_URI || `${window.location.origin}/`,
  scope: process.env.REACT_APP_OAUTH_SCOPE || "openid profile email",
  response_type: "code",
  post_logout_redirect_uri:
    process.env.REACT_APP_OAUTH_POST_LOGOUT_REDIRECT_URI ||
    `${window.location.origin}/`,

  // Storage configuration
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Additional settings
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,

  // Error handling
  onSigninCallback: () => {
    // Clean up URL after successful signin
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <OidcAuthProvider {...oidcConfig}>{children}</OidcAuthProvider>;
};

// Re-export the useAuth hook from react-oidc-context for convenience
export { useAuth } from "react-oidc-context";
